import { cn } from '@/new/lib/utils';

export function Icon({ className }: { className: string }) {
  return <span className={cn('iconify flex shrink-0 items-center transition-colors duration-150', className)} />;
}
